var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.177%",
    y1: "13.851%",
    x2: "81.998%",
    y2: "98.134%",
    id: "yf99ovyhta"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21AD64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088242",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#yf99ovyhta)",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.97 16.072a3.938 3.938 0 0 1-.822.662 6.406 6.406 0 0 1-1.292.598c-.515.18-1.113.332-1.796.455-.682.122-1.46.199-2.333.23-.082.237-.166.493-.251.765-.086.272-.17.57-.252.892h-.056a.5.5 0 0 1-.095-.144 1.235 1.235 0 0 1-.073-.248c.037-.214.078-.425.123-.632.045-.208.093-.419.146-.633-.38 0-.739-.05-1.075-.15-.022 1.488-.369 2.854-1.04 4.096C13.423 23.321 11.897 24 9.578 24c-.933 0-1.694-.28-2.283-.84-.597-.568-.895-1.277-.895-2.129 0-.897.41-1.998 1.23-3.302l.213.08c-.552 1.051-.828 1.9-.828 2.543 0 .338.08.64.24.904.161.264.389.49.683.679.295.188.657.331 1.086.431.429.1.912.15 1.449.15.82 0 1.581-.146 2.282-.438.701-.283 1.179-.648 1.432-1.093.232-.43.347-1.062.347-1.898 0-.453-.069-.904-.207-1.352a4.301 4.301 0 0 0-.565-1.191l.616-1.358c.126.184.246.386.358.604.112.219.197.405.257.558.216.1.433.169.649.207.216.039.444.058.682.058h.258c.09 0 .183-.008.28-.023.41-.698.852-1.335 1.325-1.91a11.35 11.35 0 0 1 1.483-1.508c.44-.368.865-.655 1.275-.863.41-.207.746-.31 1.007-.31.269 0 .526.052.772.155.247.104.465.23.655.38s.341.307.453.472c.112.165.168.312.168.443 0 .314-.03.602-.09.863a3.522 3.522 0 0 1-.565 1.283 6.303 6.303 0 0 1-.374.477zm-1.42-2.543c-.21 0-.472.07-.79.207-.316.138-.66.336-1.029.593-.369.257-.747.575-1.135.955s-.757.811-1.108 1.294c.127 0 .248-.003.364-.011.115-.008.251-.02.408-.035a9.523 9.523 0 0 0 1.583-.247 12.67 12.67 0 0 0 1.673-.547c.47-.184.85-.377 1.141-.58.291-.204.478-.375.56-.513a3.317 3.317 0 0 0-.325-.397 2.897 2.897 0 0 0-.414-.362 2.236 2.236 0 0 0-.464-.26 1.23 1.23 0 0 0-.464-.097zm-2.003-3.831-.795 1.208-1.062-.92.783-1.186 1.074.898z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSa);
export default __webpack_public_path__ + "static/media/sa.131febbf2868a6b67d270063591c93d3.svg";
export { ForwardRef as ReactComponent };